import React from "react";
import { cn } from "../lib/utils";

interface ScoreBadgeProps {
  score: number;
}

export function ScoreBadge({ score }: ScoreBadgeProps) {
  // Round to 2 decimal places
  // const roundedScore = score.toFixed(2);

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill px-2 py-0.5 text-xs font-medium",
        // percentage >= 80
        //   ? "bg-green-50 text-green-700"
        //   : percentage >= 60
        //   ? "bg-blue-50 text-blue-700"
        //   : "bg-gray-50 text-gray-700"
        "bg-[rgba(72,178,205,0.1)] text-brand-teal"
      )}
    >
      Score: {score}
    </span>
  );
}
